import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { ThemeContext } from 'styled-components';

import Tabs from './tabs';
import { defaultTabs } from './tabs/uniplaces';
import { Nav, List } from './styles';
import { PartnerLogo, UniversityLogo } from '../styles';
import AuthenticatedMenu from './authenticated';
import UnauthenticatedMenu from './unauthenticated';

const HeaderDesktop = ({
  isLoggedIn,
  isAccommodationProvider,
  changeLanguageHandler,
  tabs = defaultTabs,
  Logo,
  hideUserTabs,
  hideHamburgerMenu,
  guestName,
  changeLanguageByUrlHandler
}) => {
  const loggedInState = isLoggedIn ? (
    <AuthenticatedMenu
      guestName={guestName}
      isAccommodationProvider={isAccommodationProvider}
      hideUserTabs={hideUserTabs}
      changeLanguageHandler={changeLanguageHandler}
      changeLanguageByUrlHandler={changeLanguageByUrlHandler}
    />
  ) : (
    <UnauthenticatedMenu
      changeLanguageHandler={changeLanguageHandler}
      hideHamburgerMenu={hideHamburgerMenu}
      changeLanguageByUrlHandler={changeLanguageByUrlHandler}
    />
  );

  const tabsComponent = tabs.length && !hideUserTabs ? <Tabs tabs={tabs} /> : null;
  const theme = useContext(ThemeContext);

  return (
    <Nav className="header-desk-nav">
      {theme.mobileLogoURL ? (
        <UniversityLogo src={theme.mobileLogoURL} />
      ) : theme.partnerLogoUrl ? (
        <PartnerLogo src={theme.partnerLogoUrl} />
      ) : (
        <Logo />
      )}
      <List hasTabs={tabs.length} className="middle-menu">
        {tabsComponent}
      </List>
      <List className="authlist">{tabs.length ? loggedInState : null}</List>
    </Nav>
  );
};

HeaderDesktop.propTypes = {
  changeLanguageHandler: PropTypes.func.isRequired,
  tabs: PropTypes.array,
  isLoggedIn: PropTypes.bool,
  isAccommodationProvider: PropTypes.bool,
  Logo: PropTypes.func,
  hideUserTabs: PropTypes.bool,
  hideHamburgerMenu: PropTypes.bool,
  guestName: PropTypes.string,
  changeLanguageByUrlHandler: PropTypes.bool
};

export default HeaderDesktop;
